<template>
  <div>
    <ReturnArchiveModal3 :returnPDF = "returnedPDF" :isLoading = "modal3IsLoading"/>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">{{ translations('navbar.return_management') }}</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ translations('return.archive_return') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-2">
        <div class="form-group mr-2">
          <router-link class="btn btn-primary" to="new-return">{{ translations('common.addition') }}</router-link>
        </div>
        <div class="form-group mr-3">
          <input type="text" class="form-control" v-model="dtSearch" :placeholder="translations('common.keyword_search')">
        </div>
        <div class="form-group">
          <span class="mr-2">{{ translations('common.period') }}</span>
          <button @click="setFilterLastMonth()" class="btn btn-secondary mr-1 mb-2 mb-md-0">{{ translations('return.previous_month') }}</button>
          <button @click="setFilterCurrentMonth()" class="btn btn-info mr-3 mb-2 mb-md-0">{{ translations('return.current_month') }}</button>
<!--          <input type="date" v-model="dateFrom" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateFromField = dateFrom">-->
          <input type="date" v-model="dateFrom" class="form-control">
          <span class="mr-1 ml-1">〜</span>
<!--          <input type="date" v-model="dateTo" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateToField = dateTo">-->
          <input type="date" v-model="dateTo" class="form-control">
        </div>
      </div>
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
        <div class="form-group mr-1">
          <div class="dropdown">
            <button ref="txtState" class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxtStatus (return_statuses_drop_down, searchParam.return_status_id, 'name', translations('return.return_status')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('return_status_id', '')" class="dropdown-item" href="javascript:;">&nbsp;</a>
              <a @click.self="selectFilterArg('return_status_id', 10)" class="dropdown-item" href="javascript:;">{{ translations('return.pending_approval') }}</a>
              <a @click.self="selectFilterArg('return_status_id', 11)" class="dropdown-item" href="javascript:;">{{ translations('return.approved') }}</a>
              <template v-for="(status, i) in return_statuses_drop_down">
                <a :key="i" @click.self="selectFilterArg('return_status_id', status.id)" class="dropdown-item" href="javascript:;">{{ status.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group mr-1">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (return_states, searchParam.return_state_id, 'name', translations('return.operation_confirmation')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('return_state_id', '')" class="dropdown-item" href="#">&nbsp;</a>
              <template v-for="(state, i) in return_states">
                <a :key="i" @click.self="selectFilterArg('return_state_id', state.id)" class="dropdown-item" href="#">{{ state.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group mr-3">
          <v-select
            :value="master_clients.find(m => m.id === searchParam.client_id) || ''"
            :options="master_clients"
            label="name"
            :placeholder="translations('return.billing_address')"
            id="client_id"
            @input="changedClient">
          </v-select>
        </div>
        <div class="form-group mr-3">
          <v-select class="v-select-absolute" :options="makers" label="name" value="id" v-model="maker" :clearable="false" v-on:input="selectFilterArg('maker_id', maker.id)"></v-select>
        </div>
        <div class="form-group mr-3">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (master_mywarehouses, searchParam.warehouse_id, 'name', translations('return.warehouse')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('warehouse_id', '')" class="dropdown-item" href="#">&nbsp;</a>
              <template v-for="(mywarehouse, i) in master_mywarehouses">
                <a :key="i" @click.self="selectFilterArg('warehouse_id', mywarehouse.id)" class="dropdown-item" href="#">{{ mywarehouse.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" v-model="searchParam.show_completed" type="checkbox" value="" id="defaultCheck1">
            <label class="form-check-label" for="defaultCheck1">
              {{ translations('return.also_display_processed') }}
            </label>
          </div>
        </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
        <div class="form-group ml-2">
          <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
        </div>
        </div>
        <div class="form-group">
          <div class="form-group mt-1">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{ translations('common.csv_export') }}</button>
          </div>
<!--          <a href="#" @click.self="export_csv_eng()" class="btn btn-sm btn-link decoration-underline">{{ translations('return.export_return_csv') }}</a>-->
<!--          <a href="#" @click.self="export_csv()" class="btn btn-sm btn-link decoration-underline">{{ translations('return.export_csv') }}</a>-->
        </div>
      </div>
      <div class="table-scroll mb-4 table-return">
        <v-data-table
          class="table table-striped table-hover table-2000 table-clickable"
          item-key="name"
          :headers="[
            { text: 'No', value: '', sortable: false },
            { text: translations('return.processed'), value: 'return_status_id' },
            { text: translations('return.return_status'), value: 'return_status_id' },
            { text: '', value: 'action', sortable: false},
            { text: translations('return.organization_number'), value: 'reference_number' },
            { text: translations('return.arrival_date'), value: 'arrived_at' },
            { text: translations('return.return_date'), value: 'returned_at' },
            { text: translations('return.billing_address'), value: 'younosuke_company_name' },
            { text: translations('return.delivery_address'), value: 'destination_name' },
            { text: translations('return.warehouse'), value: 'kaishu_warehouse_name' },
            { text: translations('return.model_number'), value: 'model' },
            { text: translations('return.quantity'), value: 'quantity' },
            { text: translations('return.unit_price'), value: 'selling_price' },
            { text: translations('return.summary'), value: 'remarks' },
            { text: translations('return.maker'), value: 'maker_name' },
            { text: translations('return.cost_price'), value: 'row_price' },
            { text: translations('return.reason_return'), value: 'return_reason_id' },
            { text: translations('return.operation_confirmation'), value: 'return_state_id' },
            { text: translations('return.verification_results'), value: 'test_result' },
            { text: translations('return.return_rate'), value: 'return_rate' },
          ]"
          :items="returns"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for='(ret, i) in items' :key="i" data-href="" @click="openReturnDetails(ret,$event)">
                  <td>{{i + 1}}</td>
                  <td v-if="ret.is_processed"><span class="badge badge-is-processed">{{ translations('return.processed') }}</span></td>
                  <td v-else></td>
                  <td>
                    <ul>
                      <template v-for="(detail, ii) in ret.details">
                        <li :key="ii" v-html="setStatusBadge(detail)"></li>
                      </template>
                    </ul>
                  </td>
                  <td class="td-status-admin" data-action="true">
                    <button
                      ref='statusEmail'
                      type='button'
                      class='btn-sm btn-info show_status'
                      data-toggle='popover-x'
                      v-bind:data-target= "`popover-status-email-${ret.id}`"
                      data-placement='right'
                      @click="showPopUpAdminStatus(ret,$event)"
                      v-if="!showButtonEmail(ret)"
                    >
                      {{ translations('return.unapproved') }}
                    </button>
                    <div v-bind:id="`popover-status-email-${ret.id}`" class='popover popover-x popover-default popclose-all'>
                      <div class='arrow status'></div>
                      <div class='popover-body d-flex status'>
                        <button @click="hidePopUpAdminStatus(ret,$event)" class='close status' data-dismiss='popover-x'>&times;</button>
                        <ul style="margin:0">
                          <li class="list-status" v-for="(status, i) in adminStatus" :key="i">
                            <span class="admin-name">{{status.user_name }}</span>
                            <span v-bind:class="{ 'text-status': status.status === '1' }" class="status-space">{{ status.status === '1' ? '承認済み' : '未承認'}}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                  <td>{{ ret.reference_number }}</td>
                  <td>{{ $invoiceTools.formatDate(ret.arrived_at) }}</td>
                  <!-- API document says variable is "reference_number" -->
                  <td>{{ $invoiceTools.formatDate(ret.returned_at) }}</td>
                  <td>{{ ret.client_name }}</td>
                  <td>{{ ret.destination_name }}</td>
                  <td>{{ ret.warehouse_name }}</td>
                  <td>
                    <ul>
                      <template v-for='(detail, vii) in ret.details'>
                        <li :key="vii">{{ detail.model || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, ix) in ret.details">
                        <li :key="ix">{{ $invoiceTools.parseTxtNum(detail.quantity) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, viii) in ret.details">
                        <li :key="viii">{{ $invoiceTools.parseTxtNum(detail.selling_price) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, xi) in ret.details">
                        <li :key="xi">{{ detail.remarks || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for='(detail, vi) in ret.details'>
                        <li :key='vi'>{{ detail.maker_name || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, xii) in ret.details">
                        <li :key="xii">{{ $invoiceTools.parseTxtNum(detail.row_price) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, iii) in ret.details">
                        <li :key="iii">{{ $invoiceTools.getObjPropsById(return_reasons, detail.return_reason_id, 'name') }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, iv) in ret.details">
                        <li :key="iv">{{ $invoiceTools.getObjPropsById(return_states, detail.return_state_id, 'name') }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for='(detail, v) in ret.details'>
                        <li :key="v">{{ detail.test_result || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, x) in ret.details">
                        <li :key="x">{{ detail.return_rate || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="17" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ReturnArchiveModal3 from '@/components/ReturnArchiveModal3'
import { saveAs } from 'file-saver'
import $ from 'jquery'
import { MapReturnStatusAdminEmail, StatusProduct } from '../constants'
import { mapState } from 'vuex'

var Papa = require('papaparse')
var encoding = require('encoding-japanese')

export default {
  name: 'ArchiveReturn',
  props: {},
  components: {
    VueElementLoading,
    ReturnArchiveModal3
  },
  data () {
    return {
      returns: [],
      adminStatus: [],
      dateFrom: '',
      dateTo: '',
      tempDateFromField: '',
      tempDateToField: '',
      dtSearch: '',
      searchParam: {
        return_status_id: '',
        return_state_id: '',
        client_id: '',
        maker_id: '',
        warehouse_id: '',
        show_completed: '',
        start_at: '',
        end_at: ''
      },
      isSearching: false,
      makers: [],
      bill: {},
      warehouse: {},
      maker: {},
      isEmpty: false,
      isEmptyMsg: '',
      returnIds: [],
      returnedPDF: [],
      modal3IsLoading: false,
      csvField: [],
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      stopWatch: false,
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_statuses () {
      const statuses = this.$store.getters['Return/getStatuses']
      return this.translateStatuses(statuses)
    },
    return_statuses_drop_down () {
      const statuses = this.$store.getters['Return/getStatuses']
      const filteredStatuses = statuses.filter(status => StatusProduct.includes(status.id))
        .sort((a, b) => {
          return StatusProduct.indexOf(a.id) - StatusProduct.indexOf(b.id)
        })
      return this.translateStatuses(filteredStatuses)
    },
    return_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    master_clients () {
      return [{ id: 0, name: '請求先' }].concat(this.$store.getters['Master/getBillToAdded']).filter(client => client.id !== -2)
    }
  },
  watch: {
    searchParam: {
      handler (v) {
        // if (!this.stopWatch) {
        //   this.initList('searchParam')
        // }
      },
      deep: true
    },
    page () {
      this.getFilterList()
    },
    options: {
      handler () {
        if (!this.stopWatch) {
          let visitCount = Number(localStorage.getItem('visitCountReturn')) || 0
          if (visitCount > 0) {
            this.initList('options')
          }
        }
      },
      deep: true
    }
  },
  created () {
    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Return/checkStatuses')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkBillToAdded')

    this.getVenderList()

    const storedFilter = this.$storage.get('returnFltrParam')
    const sortParams = this.$storage.get('returnFltrSortParam')

    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.searchParam = storedFilter
      this.bill.id = storedFilter.client_id
      this.warehouse.id = storedFilter.warehouse_id
      this.maker.id = storedFilter.maker_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      if (sortParams) {
        this.options.sortBy = sortParams.orderbys
        this.options.sortDesc = sortParams.is_descs
      }
    } else {
      this.setFilterCurrentMonth()
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    showButtonEmail (ret) {
      if (ret.is_send_mail === '1' && (ret.numberConfirmEmail >= 0 && ret.numberConfirmEmail <= 3)) {
        return false
      }
      return true
    },
    hidePopUpAdminStatus () {
      $('.popclose-all').hide()

      $('.table-return .v-data-table__wrapper').css({
        'overflow-y': 'auto'
      })
      $('.table-return').css({
        'overflow-x': 'scroll'
      })
    },
    showPopUpAdminStatus (ret, event) {
      if (event) {
        event.preventDefault()
      }
      let returnId = ret.id
      this.isSearching = true
      this.$http.post(this.$api_url.return_details, { return_id: returnId }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isSearching = false
          this.adminStatus = result.adminStatus
        }
      }).finally(() => {
        this.isSearching = false
        $('.popclose-all').hide()
        $('.table-return .v-data-table__wrapper').css({
          'overflow': 'initial'
        })
        $('.table-return').css({
          'overflow': 'initial'
        })

        $(`#popover-status-email-${returnId}`).show()
      })
    },
    // changeSearch (e) {
    //   this.$storage.set('ArchiveReturn:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList('changeSearch')
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.searchParam.start_at = this.dateFrom
    //     this.initList('triggerDateFilter')
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.searchParam.end_at = this.dateTo
    //     this.initList('triggerDateFilter')
    //   }
    // },

    initList (call) {
      if (this.page !== 1) {
        this.page = 1
      } else {
        if (call === 'created') {
          let { page } = this.$router.history.current.query
          this.page = page ? parseInt(page) : 1
        }
        this.getFilterList()
      }
    },

    getFilterList (field, val) {
      this.hidePopUpAdminStatus()
      if (this.isSearching) {
        return
      }

      if (this.displayAll) {
        this.$storage.set('return_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      this.isSearching = true

      const params = JSON.parse(JSON.stringify(this.searchParam))

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      params.offset = offset
      params.limit = limit
      params.orderbys = orderbys
      params.is_descs = isDescs
      params.search = this.dtSearch
      params.start_at = (this.dateFrom) ? this.dateFrom : ''
      params.end_at = (this.dateTo) ? this.dateTo : ''

      this.$storage.set('returnFltrSortParam', params)
      this.$storage.set('returnFltrParam', params)

      this.$http.post(this.$api_url.return_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.returns = result.list
          localStorage.setItem('visitCountReturn', this.returns.length)
          this.totalCount = Number(result.total_count)
        } else {
          this.returns = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchiveReturn:API:getFilterList: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('return.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        if (this.stopWatch === true) {
          this.stopWatch = false
        }
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },
    getVenderList () {
      return this.$http.post(this.$api_url.vander_list).then(response => {
        const result = response.data
        if (result.status === true) {
          this.makers = result.list
        } else {
          return Promise.reject(new Error(result.message))
        }
        this.makers.unshift({ id: '', name: 'メーカー' })
        const filtered = this.makers.filter(v => {
          return v.id === this.maker.id
        })[0]
        this.maker = filtered || { id: '', name: 'メーカー' }
      }).catch(function (error) {
        console.log('ArchiveReturn:getVenderList:catch(error): ', error)
        return Promise.reject(new Error(this.translations('return.notice_failed')))
      })
    },

    selectFilterArg (filter, val) {
      console.log(this.searchParam)
      this.searchParam[filter] = val
    },

    getFilterTxt (obj, input, output, _default) {
      if (input === 0 || input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },
    getFilterTxtStatus (obj, input, output, _default) {
      if (input === MapReturnStatusAdminEmail.waitConfirm) {
        return MapReturnStatusAdminEmail.waitConfirmText
      }
      if (input === MapReturnStatusAdminEmail.allConfirm) {
        return MapReturnStatusAdminEmail.allConfirmText
      }
      if (input === 0 || input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    setFilterCurrentMonth () {
      const $date = new Date()
      const y = $date.getFullYear()
      const m = ('0' + ($date.getMonth() + 1)).slice(-2)
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
    },

    setFilterLastMonth () {
      const $date = new Date()
      const m = ($date.getMonth() !== 0) ? ('0' + ($date.getMonth())).slice(-2) : 12
      const y = (m !== 12) ? $date.getFullYear() : $date.getFullYear() - 1
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
      this.initList()
    },

    openReturnDetails (ret, event) {
      if ($(event.target).parents('td')[0] && $(event.target).parents('td')[0].getAttribute('data-action') === 'true') {
        return false
      }
      this.$router.push({ name: 'single-return', query: { return_id: ret.id, pageBack: this.page } })
    },

    async export_csv_eng () {
      let csvData = []
      this.csvField = ['Arrival date', 'Return date', 'Store name-ENGLISH', 'Store name-JAPANESE', 'Model', 'Currency', 'Unit Price', 'Quantity', 'Amount', 'Descriptions-ENGLISH', 'Descriptions-JAPANESE']

      this.returns.forEach(ret => {
        let csvTemp = { status: '', reasons: '', reasons_eng: '', state: '', testResult: '', maker_name: '', model: '', row_price: '', buying_price: '', currency: '', quantity: '', selling_price: '', returnRate: '', remarks: '' }
        ret.details.forEach(detail => {
          csvTemp.status = (this.$invoiceTools.getObjPropsById(this.return_statuses, detail.return_status_id, 'name'))
          csvTemp.reasons = (this.$invoiceTools.getObjPropsById(this.return_reasons, detail.return_reason_id, 'name'))
          csvTemp.reasons_eng = (this.$invoiceTools.getObjPropsById(this.return_reasons, detail.return_reason_id, 'name_eng'))
          csvTemp.state = (this.$invoiceTools.getObjPropsById(this.return_states, detail.return_state_id, 'name'))
          csvTemp.testResult = (detail.test_result)
          csvTemp.maker_name = (detail.maker_name)
          csvTemp.model = (detail.model)
          csvTemp.row_price = Number(detail.row_price)
          csvTemp.buying_price = (detail.buying_price) // .00
          csvTemp.currency = (detail.currency)
          csvTemp.quantity = Number(detail.quantity)
          csvTemp.selling_price = Number(detail.selling_price)
          csvTemp.returnRate = (detail.return_rate)
          csvTemp.remarks = (detail.remarks)

          csvData.push([
            this.$invoiceTools.formatDate(ret.arrived_at), // 到着日
            this.$invoiceTools.formatDate(ret.returned_at), // 返品日
            ret.destination_eng, // 納品先 ENG
            ret.destination_name, // 納品先
            csvTemp.model, // 型番
            csvTemp.currency, // 通貨
            csvTemp.buying_price, // 原価
            csvTemp.quantity, // 数量
            csvTemp.buying_price * csvTemp.quantity, // 原価 合計
            csvTemp.reasons_eng, // 返品理由 ENG
            csvTemp.reasons // 返品理由
          ])
        })
      })

      let csv = Papa.unparse({
        fields: this.csvField,
        data: csvData
      })

      let detected = encoding.detect(csv)
      this.$invoiceTools.log('encoding: ', [detected, csv])

      let unicodeList = encoding.stringToCode(csv)
      this.$invoiceTools.log('unicodeList: ', unicodeList)

      let sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      let uInt8List = new Uint8Array(sjisArray)

      detected = encoding.detect(sjisArray)
      this.$invoiceTools.log('sjisArray: ', [detected, sjisArray])

      detected = encoding.detect(uInt8List)
      this.$invoiceTools.log('uInt8List: ', [detected, uInt8List])

      // let content = new Blob(['\ufeff', csv], { type: 'data:application/csv;charset=utf-8,' })
      let content = new Blob([uInt8List], { type: 'text/csv' })
      detected = encoding.detect(content)
      this.$invoiceTools.log('content: ', [detected, content])

      const d = new Date()
      let filename = '[Eng] Return List ' + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'

      saveAs(content, filename)
    },

    async export_csv () {
      let csvData = []
      this.csvField = ['ステータス', '整理番号', '処理日', '返品日', '請求先', '納品先', '型番', '数量', '単価', '単価合計', '摘要', '倉庫', 'メーカー', '原価', '返品理由', '動作確認', '検証結果', '返品率']

      this.returns.forEach(ret => {
        let csvTemp = { status: '', reasons: '', state: '', testResult: '', maker_name: '', model: '', cost: '', buying_price: '', currency: '', quantity: '', selling_price: '', returnRate: '', remarks: '' }
        ret.details.forEach(detail => {
          csvTemp.status = (this.$invoiceTools.getObjPropsById(this.return_statuses, detail.return_status_id, 'name'))
          csvTemp.reasons = (this.$invoiceTools.getObjPropsById(this.return_reasons, detail.return_reason_id, 'name'))
          csvTemp.state = (this.$invoiceTools.getObjPropsById(this.return_states, detail.return_state_id, 'name'))
          csvTemp.testResult = (detail.test_result)
          csvTemp.maker_name = (detail.maker_name)
          csvTemp.model = (detail.model)
          csvTemp.cost = (detail.cost)
          csvTemp.buying_price = (Number(detail.buying_price)) // .00
          csvTemp.currency = (detail.currency)
          csvTemp.quantity = (detail.quantity)
          csvTemp.selling_price = (detail.selling_price)
          csvTemp.returnRate = (detail.return_rate)
          csvTemp.remarks = (detail.remarks)

          csvData.push([
            csvTemp.status, // ステータス
            ret.reference_number, // 整理番号
            this.$invoiceTools.formatDate(ret.arrived_at), // 処理日
            this.$invoiceTools.formatDate(ret.returned_at), // 返品日
            ret.client_name, // 請求先
            ret.destination_name, // 納品先
            csvTemp.model, // 型番
            csvTemp.quantity, // 数量
            csvTemp.selling_price, // 単価
            csvTemp.selling_price * csvTemp.quantity, // 単価合計
            csvTemp.remarks, // 摘要
            ret.warehouse_name, // 倉庫
            csvTemp.maker_name, // メーカー
            csvTemp.buying_price + ' ' + csvTemp.currency, // 原価 通貨
            csvTemp.reasons, // 返品理由
            csvTemp.state, // 動作確認
            csvTemp.testResult, // 検証結果
            csvTemp.returnRate // 返品率
          ])
        })
        // 'ステータス', '整理番号', '処理日', '返品日', '請求先', '納品先', '型番', '数量', '単価', '単価合計', '摘要', '倉庫', 'メーカー', '原価', '返品理由', '動作確認', '検証結果', '返品率'
      })

      let csv = Papa.unparse({
        fields: this.csvField,
        data: csvData
      })

      let detected = encoding.detect(csv)
      this.$invoiceTools.log('encoding: ', [detected, csv])

      let unicodeList = encoding.stringToCode(csv)
      this.$invoiceTools.log('unicodeList: ', unicodeList)

      let sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      let uInt8List = new Uint8Array(sjisArray)

      detected = encoding.detect(sjisArray)
      this.$invoiceTools.log('sjisArray: ', [detected, sjisArray])

      detected = encoding.detect(uInt8List)
      this.$invoiceTools.log('uInt8List: ', [detected, uInt8List])

      // let content = new Blob(['\ufeff', csv], { type: 'data:application/csv;charset=utf-8,' })
      let content = new Blob([uInt8List], { type: 'text/csv' })
      detected = encoding.detect(content)
      this.$invoiceTools.log('content: ', [detected, content])

      const d = new Date()
      let filename = 'Return List ' + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'

      saveAs(content, filename)
    },

    setStatusBadge (detail) {
      let statusName = this.$invoiceTools.getObjPropsById(this.return_statuses, detail.return_status_id, 'name')
      let bClass = ''
      switch (detail.return_status_id) {
        case 2:
          bClass = ' badge-shinpin'
          break
        case 9:
          bClass = ' badge-outlet'
          break
        default:
          bClass = ' badge-misyori'
      }
      return '<span class="badge ' + bClass + '">' + statusName + '</span>'
    },

    // searchTargets () {
    //   this.returns.forEach(ret => {
    //     let searchTypeNumber = ''
    //     let searchAmount = ''
    //     let searchSellingPrice = ''
    //     let searchMemo = ''
    //     let searchVender = ''
    //     let searchCost = ''
    //     let searchReturnRate = ''
    //     ret.details.forEach(detail => {
    //       if (searchTypeNumber) searchTypeNumber += ','
    //       searchTypeNumber += detail.model
    //       if (searchAmount) searchAmount += ','
    //       searchAmount += detail.amount
    //       if (searchSellingPrice) searchSellingPrice += ','
    //       searchSellingPrice += detail.selling_price
    //       if (searchMemo) searchMemo += ','
    //       searchMemo += detail.memo
    //       if (searchVender) searchVender += ','
    //       searchVender += detail.vender
    //       if (searchCost) searchCost += ','
    //       searchCost += detail.cost
    //       if (searchReturnRate) searchReturnRate += ','
    //       searchReturnRate += detail.return_rate
    //     })
    //     ret.model = searchTypeNumber
    //     ret.amount = searchAmount
    //     ret.selling_price = searchSellingPrice
    //     ret.memo = searchMemo
    //     ret.vender = searchVender
    //     ret.cost = searchCost
    //     ret.return_rate = searchReturnRate
    //   })
    // }

    changedClient (event) {
      if (!event) {
        this.selectFilterArg('client_id', 0)
        return
      }
      this.selectFilterArg('client_id', event.id)
      this.searchParam.client_id = event.id
    },
    submitSearch () {
      if (!this.stopWatch) {
        this.initList('searchParam')
      }
      this.initList('changeSearch')
      this.initList('triggerDateFilter')
    },

    exportCsv (field, val) {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const params = JSON.parse(JSON.stringify(this.searchParam))

      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      params.orderbys = orderbys
      params.is_descs = isDescs
      params.search = this.dtSearch
      params.start_at = (this.dateFrom) ? this.dateFrom : ''
      params.end_at = (this.dateTo) ? this.dateTo : ''

      this.$storage.set('returnFltrParam', params)

      this.$http.post(this.$api_url.return_csv, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
        } else {
          this.returns = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(error => {
        console.log('ArchiveReturn:API:exportCsv: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('return.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        if (this.stopWatch === true) {
          this.stopWatch = false
        }
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        item.details.forEach(detail => {
          const processed = item.processed ? this.translations('reutrn.processed') : ''
          const returnStatus = this.$invoiceTools.getObjPropsById(this.return_statuses, detail.return_status_id, 'name')
          const returnReasons = this.$invoiceTools.getObjPropsById(this.return_reasons, detail.return_reason_id, 'name')
          const returnReasonsEng = this.$invoiceTools.getObjPropsById(this.return_reasons, detail.return_reason_id, 'name_eng')
          const returnStates = this.$invoiceTools.getObjPropsById(this.return_states, detail.return_state_id, 'name')
          data.push([
            processed,
            returnStatus,
            item.reference_number,
            item.arrived_at,
            item.returned_at,
            item.client_name,
            item.destination_name,
            item.warehouse_name,
            detail.model,
            detail.quantity,
            detail.selling_price,
            detail.remarks ? detail.remarks : '-',
            detail.maker_name,
            detail.row_price,
            this.currentLanguage === 'en' ? returnReasonsEng : returnReasons,
            returnStates,
            detail.test_result ? detail.test_result : '-',
            detail.return_rate ? detail.return_rate : '-'
          ])
        })
      })

      let csv = ''
      let fields = [
        this.translations('return.processed'),
        this.translations('return.return_status'),
        this.translations('return.organization_number'),
        this.translations('return.arrival_date'),
        this.translations('return.return_date'),
        this.translations('return.billing_address'),
        this.translations('return.delivery_address'),
        this.translations('return.warehouse'),
        this.translations('return.model_number'),
        this.translations('return.quantity'),
        this.translations('return.unit_price'),
        this.translations('return.summary'),
        this.translations('return.maker'),
        this.translations('return.cost_price'),
        this.translations('return.reason_return'),
        this.translations('return.operation_confirmation'),
        this.translations('return.verification_results'),
        this.translations('return.return_rate')
      ]

      csv = Papa.unparse({
        fields: fields,
        data: data
      })
      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('return.return_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-returns{
  margin-top: 0 !important
}
.td-status-admin {
  position: relative;
}
.show_status {
  margin-left:5px;
  color:red;
}
.list-status {
  width: 160px;
  display: flex;
  margin-bottom: 5px;
}
.admin-name {
  width: 60%;
}
.popover-x.right > .arrow.status {
  left: -15px;
}
.popover-body.status {
  padding: 20px;
  background: #fff;
}
.close.status {
    position: absolute;
    top: 0;
    right: 3px;
}
.text-status {
  color: #106710;
}
.isShowButtonApproved {
  position: absolute;
  top: 0;
  right: 0;
}
.form-line-po {
  position: relative;
}
.td-status-admin .popover {
  top: 0;
  left: 95px;
}
.td-status-admin .popover-body::after{
    z-index: -10;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 0;
    bottom: 0;
    top: 20px;
    left:0;
    box-sizing: border-box;
    border: 7px solid #fff;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: rotate(45deg);
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.4);
  }
.td-status-admin .popover-body::before{
    z-index: 10;
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    margin-left: 0;
    bottom: 0;
    top: 20px;
    left:0;
    box-sizing: border-box;
    border: 7px solid black;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: rotate(45deg);
  }
  .table-return .v-data-table__wrapper {
    overflow-y:auto;
  }
  .table-return .table-scroll {
    overflow-x:auto;
  }
</style>
